<template>
  <div class="flex flex-wrap items-center gap-4 py-4 pl-5 pr-4 sm:py-0.5">
    <div class="min-w-0 flex-[2]">
      <slot name="title" />
    </div>

    <div class="min-w-0 flex-[5] max-sm:order-last max-sm:w-full max-sm:flex-none">
      <slot name="description" />
    </div>

    <div class="min-w-0 max-sm:self-start max-sm:pt-1 sm:flex-[2]">
      <slot name="count" />
    </div>

    <!-- Hidden on mobile -->
    <div class="hidden w-28 text-right sm:block">
      <slot name="modified" />
    </div>

    <div class="w-5 min-w-0 max-sm:-translate-y-1 max-sm:self-start">
      <slot name="menu" />
    </div>
  </div>
</template>
